module.exports = __webpack_public_path__ + "img/Skirt-Front-B10-Cb-Ha.4aa92889.png";